/*currency symbol*/


$( document ).ready(function() {
  $("html").attr("data-page-url", window.location.pathname);


  
  var currencySymbol = $( ".currencies option:selected" ).text();
  var splitCurrencySymbol = currencySymbol.split(' ', 1)[0];
  setTimeout(function() { 
  var checkStr = $( ".nosto_element span.money" ).text();
  if(checkStr.includes('TWD') || checkStr.includes('THB') || checkStr.includes('HK') || checkStr.includes('SGD') ){
  }else{
   $('.nosto_element span.money').append(' ' + splitCurrencySymbol);
  }
  
  }, 2000);

});

function syncQuickViewSizeOptions(){
  $(".custom-pg-variant-option-details[data-quick-view-dropdown]").each(function(){
    if(window.innerWidth > 550){
      $(this).attr("open", "open");
    }
    else{
      $(this).removeAttr("open");
    }
  });
}

function triggerQuickViewKlaviyoBis(variantId, $scope){
  if(!variantId){
    return false;
  }

  try{
    var $card = $scope && $scope.length ? $scope.closest(".jci-product-card-wrapper") : $();
    var $root = $card.length ? $card : ($scope && $scope.length ? $scope.closest(".custom-pg-main-wrapper") : $());
    var $form = $scope && $scope.length ? $scope.find('form[action*="/cart/add"]').first() : $();
    var $trigger = $scope && $scope.length ? $scope.find(".klaviyo-button-container .klaviyo-bis-trigger, .klaviyo-button-container button, .klaviyo-button-container a").first() : $();

    if(!$trigger.length){
      $trigger = $root.find(".klaviyo-button-container .klaviyo-bis-trigger, .klaviyo-button-container button, .klaviyo-button-container a").first();
    }

    if(!$form.length || !$trigger.length){
      return false;
    }

    $form.find('input[name="id"]').val(variantId).attr("value", variantId).trigger("change");
    $scope.find(".custom-pg-master-select").val(String(variantId)).trigger("change");
    $trigger.closest(".custom-pg-klaviyo-product-container").addClass("custom-pg-klaviyo-product-container--clicking");
    $trigger[0].click();
    $trigger.closest(".custom-pg-klaviyo-product-container").removeClass("custom-pg-klaviyo-product-container--clicking");

    return true;
  }
  catch(error){
    return false;
  }
}

function updateQuickViewButtonState($scope){
  if(!$scope || !$scope.length){
    return;
  }

  let $button = $scope.find(".custom-pg-atc");
  let notifyDisabled = $button.attr("data-disable-notify") === "true";
  let $checkedInputs = $scope.find(".custom-pg-variant-option-input:checked");
  let variants = [];
  let isSingleVariant = false;
  let requiresSelection = false;
  let hasSelectedSize = $scope.find(".custom-pg-variant-option-input--size:checked").length > 0;
  let selectedValues = {};
  let selectedOptionKeys = [];

  try{
    variants = JSON.parse($scope.find(".custom-pg-variants-json").text() || "[]");
  }
  catch(error){
    variants = [];
  }

  isSingleVariant = variants.length === 1 || $scope.find(".custom-pg-master-select option").length === 1;
  requiresSelection = !isSingleVariant && $scope.find(".custom-pg-variant-option-input--size").length > 0;

  $checkedInputs.each(function(){
    selectedValues[String($(this).data("optionPosition"))] = $(this).val();
  });
  selectedOptionKeys = Object.keys(selectedValues);

  if(requiresSelection && !hasSelectedSize){
    $button
      .addClass("first_click")
      .removeClass("klaviyo-bis-trigger sold")
      .attr("data-mode", "add")
      .text("Add to Bag");
    return;
  }

  if(!selectedOptionKeys.length){
    let $defaultOption = $scope.find(".custom-pg-master-select option").first();
    if($defaultOption.length){
      let isAvailable = $defaultOption.attr("data-available") === "true";
      $scope.find(".custom-quick-view-popup-price").html($defaultOption.attr("data-price"));
      $button.removeClass("first_click");
      if(isAvailable){
        $button
          .removeClass("klaviyo-bis-trigger sold")
          .attr("data-mode", "add")
          .attr("data-id", $defaultOption.val())
          .text("Add to Bag");
        $scope.find(".custom-pg-variant-id").val($defaultOption.val());
      } else {
        $button
          .toggleClass("klaviyo-bis-trigger", !notifyDisabled)
          .addClass("sold")
          .attr("data-mode", notifyDisabled ? "sold" : "notify")
          .attr("data-id", $defaultOption.val())
          .text(notifyDisabled ? "Sold Out" : "Notify me when available");
        $scope.find(".custom-pg-variant-id").val($defaultOption.val());
      }
    }
    return;
  }

  let matchedVariant = variants.find(function(variant){
    for(let index = 1; index <= 3; index += 1){
      if(selectedValues[String(index)] && variant["option" + index] !== selectedValues[String(index)]){
        return false;
      }
    }
    return true;
  });

  if(matchedVariant){
    let $matchedOption = $scope.find('.custom-pg-master-select option[value="' + matchedVariant.id + '"]');
    $scope.find(".custom-pg-master-select").val(String(matchedVariant.id)).trigger("change");
    if($matchedOption.length){
      $scope.find(".custom-quick-view-popup-price").html($matchedOption.attr("data-price"));
    }

    $button.removeClass("first_click");

    if(matchedVariant.available){
      $button
        .removeClass("klaviyo-bis-trigger sold")
        .attr("data-mode", "add")
        .attr("data-id", matchedVariant.id)
        .text("Add to Bag");
      $scope.find(".custom-pg-variant-id").val(matchedVariant.id);
    } else {
      $button
        .toggleClass("klaviyo-bis-trigger", !notifyDisabled)
        .addClass("sold")
        .attr("data-mode", notifyDisabled ? "sold" : "notify")
        .attr("data-id", matchedVariant.id)
        .text(notifyDisabled ? "Sold Out" : "Notify me when available");
      $scope.find(".custom-pg-variant-id").val(matchedVariant.id);
    }
  } else {
    $button
      .addClass("first_click")
      .removeClass("klaviyo-bis-trigger sold")
      .attr("data-mode", "add")
      .text("Add to Bag");
  }
}

function resetQuickViewSelections($popupWrapper){
  if(!$popupWrapper || !$popupWrapper.length){
    return;
  }

  let $scope = $popupWrapper.find(".custom-quick-view-popup-info");
  let isSingleVariant = false;

  try{
    isSingleVariant = JSON.parse($scope.find(".custom-pg-variants-json").text() || "[]").length === 1;
  }
  catch(error){
    isSingleVariant = $scope.find(".custom-pg-master-select option").length === 1;
  }

  $scope.find(".custom-pg-variant-option-input--size").prop("checked", isSingleVariant);
  $scope.find(".custom-pg-variant-option-input").not(".custom-pg-variant-option-input--size").each(function(){
    let shouldCheck = $(this).is("[checked]");
    $(this).prop("checked", shouldCheck);
  });
  $scope.find(".custom-pg-variant-option-details[data-quick-view-dropdown]").each(function(){
    let $summaryText = $(this).find(".custom-pg-variant-option-summary span");
    let $selected = $(this).find(".custom-pg-variant-option-input:checked").first();
    if($summaryText.length && $selected.length){
      $summaryText.text($selected.val());
    }
  });
  updateQuickViewButtonState($scope);
}

$(window).on("resize", syncQuickViewSizeOptions);
$(document).ready(syncQuickViewSizeOptions);



$(document).on('click', '.custom-hide-filter-btn', function() {
  console.log('test', prodGridCols - 1);
  $("#main-collection-filters").removeClass("active");
  $(".custom-show-filter-btn").show();
  $("#product-grid").removeClass(`grid--${prodGridCols - 1}-col-desktop`).addClass(`grid--${prodGridCols}-col-desktop`);
})
$(document).on('click', '.custom-filter-toggle .custom-show-filter-btn', function() {
  //$(this).hide();
  $("#main-collection-filters").toggleClass("active");
  $("#product-grid").removeClass(`grid--${prodGridCols}-col-desktop`).toggleClass(`grid--${prodGridCols - 1}-col-desktop`);
})
$(document).on("click", ".custom-filter-toggle .custom-filter-toggle-btn, .custom-mobile-filter-overlay, .custom-mobile-filter-close, .facets .custom-apply-filter-btn", function(){
  $(".facets-vertical facet-filters-form").toggleClass("active");
  $(".custom-mobile-filter-overlay").fadeToggle(300);
})
$(document).on("click", ".custom-pg-quick-view-btn, .custom-quick-view-popup-close, .custom-quick-view-popup-wrapper", function(e){
  e.preventDefault();
  if($(this).parents(".custom-pg-main-wrapper").length > 0){
    let $popupWrapper = $(this).parents(".custom-pg-main-wrapper").find(".custom-quick-view-popup-wrapper");
    $popupWrapper.toggleClass("active");
    $(".custom-pg-variant-option-details").removeAttr("open");
    syncQuickViewSizeOptions();
    if($popupWrapper.hasClass("active")){
      resetQuickViewSelections($popupWrapper);
    }
  }
  else{
    $(`.custom-quick-view-popup-wrapper`).removeClass("active");
    syncQuickViewSizeOptions();
  }
})
$(document).on("click", ".custom-pg-quick-view-btn-new", function(e){
  e.preventDefault();
  $(".custom-quick-view-popup-wrapper").removeClass("active")
  let $popupWrapper = $(`.custom-quick-view-popup-wrapper[data-id="${$(this).attr("data-id")}"]`);
  $popupWrapper.addClass("active");
  // $(`.custom-quick-view-popup-wrapper[data-id="${$(this).attr("data-id")}"]`).find(".custom-pg-colors-hide").find(".custom-pg-variant-option-input").eq(0).prop("checked", true);
  $(".custom-pg-variant-option-details").removeAttr("open");
  syncQuickViewSizeOptions();
  resetQuickViewSelections($popupWrapper);
  
})
$(document).on("click", ".custom-quick-view-popup", function(e){
  e.stopPropagation();
  $(".custom-pg-variant-option-details").removeAttr("open");
  syncQuickViewSizeOptions();
})
$(document).on("click", ".custom-pg-variant-option-label", function(){
  let $details = $(this).parents(".custom-pg-variant-option-details");
  if($details.is("[data-quick-view-dropdown]")){
    $details.find(".custom-pg-variant-option-summary").find("span").text($(this).prev().val());
  }
})
$(document).on("change", ".custom-pg-variant-option-input", function(){
  let $details = $(this).parents(".custom-pg-variant-option-details");
  if($details.is("[data-quick-view-dropdown]")){
    if($(this).hasClass("custom-pg-variant-option-input---color")){
      $details.find(".custom-pg-variant-option-summary").find("span").text($(this).val());
    }
    else{
      $details.find(".custom-pg-variant-option-summary").attr("data-color", $(this).attr("data-color"));
      $details.find(".custom-pg-variant-option-summary").find("span").text($(this).val());
    }
  }
  updateQuickViewButtonState($(this).parents(".custom-quick-view-popup-info"));
})
$(document).on("click", ".custom-pg-atc", function(e){
  e.preventDefault();
  if($(this).attr("data-mode") === "sold"){
    return;
  }
  if($(this).attr("data-mode") === "notify" || $(this).hasClass("klaviyo-bis-trigger")){
    triggerQuickViewKlaviyoBis($(this).attr("data-id"), $(this).closest(".custom-quick-view-popup-info"));
    return;
  }
  let $this = $(this);
  $(this).addClass("active");
  let id = $(this).attr("data-id");
  let formData = {
    'items': [{
     'id': id,
     'quantity': 1
     }],
    sections: "cart-drawer,cart-icon-bubble"
   };
   fetch(window.Shopify.routes.root + 'cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json',
       'X-Requested-With': 'xmlhttprequest'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
     return response.json();
   })
   .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      $this.removeClass("active");
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
      $(".cart-count-bubble").trigger("click");
    }
   })
   .catch((error) => {
     console.error('Error:', error);
   })
   .finally(function(){
      $this.removeClass("active");
   });
})


const customDebounce = (fn, wait, immediate = false) => {
  let timer;
  return function(...args) {
    const callNow = immediate && !timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (!immediate) fn.apply(this, args);
    }, wait);
    if (callNow) fn.apply(this, args);
  };
};

// $(document).click(function(){
//   $(".custom-search-results-main-wrapper").hide();
// })
// $(document).on("click", ".custom-search-mobile-toggle, .custom-search-close", function(e){
//   e.stopPropagation();
//   $(".custom-search-form-wrapper").toggleClass("active");
// })
// $(document).on("click", ".custom-search-input", function(e){
//   e.stopPropagation();
//   if($(this).val().length > 0){
//     $(".custom-search-results-main-wrapper").show();
//   }
//   else{
//     $(".custom-search-results-main-wrapper").hide();
//   }
// })
// $(document).on("change input paste", ".custom-search-input", customDebounce(function(){
//   let val = $(this).val();
//   if(val.length > 0){
//     $(".custom-search-results-main-wrapper").show();
//   }
//   else{
//     $(".custom-search-results-main-wrapper").hide();
//   }
//   const predictiveSearchSection = document.querySelector('.custom-search-results-main-wrapper');
//   var requestResponse;
  
//   fetch(window.Shopify.routes.root + `search/suggest?q=${val}&esources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&resources[limit_scope]=each&section_id=custom-search`)
//     .then((response) => {
//       requestResponse = response;
//       return response.text();
//      })
//     .then((text) => {
//       if (!requestResponse.ok) {
//         throw new Error(`${requestResponse.status}: ${text}`);
//       }
  
//       const resultsMarkup = new DOMParser()
//         .parseFromString(text, 'text/html')
//         .querySelector('.shopify-section').innerHTML;
  
//       predictiveSearchSection.innerHTML = resultsMarkup;
//     })
//     .catch((error) => {
//       console.error(error);
//     });
// }, 300))

// ===== SEARCH (scoped to nearest form) =====
$(document).click(function () {
  $('.custom-search-results-main-wrapper').hide();
});

// Toggle only the wrapper related to the clicked control
$(document).on('click', '.custom-search-mobile-toggle, .custom-search-close', function (e) {
  e.stopPropagation();
  // Works for both desktop (.custom-search-form-wrapper) and mobile (.jci-mobile-search)
  const $scopeWrapper = $(this).closest('.custom-search-form-wrapper, .jci-mobile-search');
  $scopeWrapper.toggleClass('active');
});

$(document).on('click', '.custom-search-input', function (e) {
  e.stopPropagation();
  const $scope   = $(this).closest('.custom-search-form-inner');
  const $results = $scope.find('.custom-search-results-main-wrapper');
  if ($(this).val().trim().length > 0) $results.show(); else $results.hide();
});

// Keep clicks inside results from closing them
$(document).on('click', '.custom-search-results-main-wrapper', function (e) {
  e.stopPropagation();
});

// Debounced predictive search — scoped to the nearest form
$(document).on('change input paste', '.custom-search-input', customDebounce(function () {
  const $scope   = $(this).closest('.custom-search-form-inner');
  const $results = $scope.find('.custom-search-results-main-wrapper');
  const val      = ($(this).val() || '').trim();

  if (!val) { $results.empty().hide(); return; }
  $results.show();

  let requestResponse;
  const url =
    window.Shopify.routes.root +
    `search/suggest?q=${encodeURIComponent(val)}&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&resources[limit_scope]=each&section_id=custom-search`; // <-- fixed "resources"

  fetch(url)
    .then((response) => {
      requestResponse = response;
      return response.text();
    })
    .then((text) => {
      if (!requestResponse.ok) throw new Error(`${requestResponse.status}: ${text}`);
      const html = new DOMParser().parseFromString(text, 'text/html')
                    .querySelector('.shopify-section').innerHTML;
      $results.html(html).show();
    })
    .catch((error) => {
      console.error(error);
      $results.hide();
    });
}, 300));

$(document).on("click", `a[href="#popup"]`, function(e){
  e.preventDefault();
  if($(".size-guide-link").length > 0){
    $(".size-guide-link")[0].dispatchEvent(new Event('click'));
  }
})


$(document).on("click", ".custom-drawer-free-prod-atc", function(){
  let $this = $(this);
  $(this).addClass("active");
  let id = $(this).attr("data-id");
  let formData = {
    'items': [{
     'id': id,
     'quantity': 1,
     'properties': {
      '_free_gift': true
     }
     }],
    sections: "cart-drawer,cart-icon-bubble"
   };
   fetch(window.Shopify.routes.root + 'cart/add.js', {
     method: 'POST',
     headers: {
       'Content-Type': 'application/json',
       'X-Requested-With': 'xmlhttprequest'
     },
     body: JSON.stringify(formData)
   })
   .then(response => {
     return response.json();
   })
   .then(res => {
    if(res.status){
      console.log(res);
    }
    else{
      $this.removeClass("active");
      const cartParsedData = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
      const cartBubbleParsedData = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
      $("cart-drawer.drawer").removeClass("is-empty");
      $(".drawer__inner").html($(cartParsedData).find(".drawer__inner").html());
      $("#cart-icon-bubble").html($(cartBubbleParsedData).find(".shopify-section").html());
    }
   })
   .catch((error) => {
     console.error('Error:', error);
   })
   .finally(function(){
      $this.removeClass("active");
   });
})
